export default "__VITE_ASSET__DfDKXLzR__"